import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        planningGroup: '='
    },
    template: `
        <div class="well color02">
             <courses-courses-edit-occurrence-automated-planning-group-steps-employee
                planning-group="vm.planningGroup"
                context="'add'"
            />
        </div>
    `
})
export default class {

}



// WEBPACK FOOTER //
// ./src/app/components/courses/courses/edit/occurrence/automated/planningGroup/add/employee/index.js